//-disable /* globals translation */
const $ = jQuery.noConflict();

export function triggerEvent( element, type ) {
	const eventDOM = document.createEvent( 'HTMLEvents' );
	eventDOM.initEvent( type, true, false );
	element.dispatchEvent( eventDOM );
}

export function loadMore( nextPageSelector = null, listSelector = null, newItemsSelector = null ) {
	// Validate required parameters
	if ( nextPageSelector === null || listSelector === null || newItemsSelector === null ) {
		throw new Error( 'function is missing required parameters' );
	}

	let nextPage = document.querySelector( nextPageSelector );
	const productList = document.querySelector( listSelector );

	// Listen to update events to the list element
	if ( productList ) {
		productList.addEventListener( 'updated', () => {
			nextPage = document.querySelector( nextPageSelector );
		} );
	}

	if ( nextPage ) {
		// Get the next page url
		let nextPageUrl = nextPage.getAttribute( 'href' );

		// Define loading, used to prevent double loading
		let loading = false;

		// Listen to update events to the list element
		if ( productList ) {
			productList.addEventListener( 'updated', () => {
				if ( nextPage ) {
					nextPageUrl = nextPage.getAttribute( 'href' );
				} else {
					nextPageUrl = null;
				}
			} );
		}

		// Generate the loading info output
		const loadingHtml = document.createElement( 'div' );
		const loadingText = document.createElement( 'span' );
		const loadingIcon = document.createElement( 'div' );
		const loadingIconInner = document.createElement( 'div' );
		loadingHtml.id = 'maksimer-loading';
		loadingIcon.className = 'loading-icon';
		loadingText.className = 'text';
		// loadingText.innerText = (typeof translation !== 'undefined' && translation.fetching_more) ? translation.fetching_more : 'Fetching more items…';
		const loader = document.getElementById( 'loader' );
		if ( loader ) {
			loader.classList.remove( 'invisible' );
			loadingIconInner.className = 'loading-icon-inner';
			loadingIcon.appendChild( loadingIconInner );
			loadingHtml.appendChild( loadingIcon );
			loadingHtml.appendChild( loadingText );
		}

		window.addEventListener( 'scroll', () => {
			if ( ( window.pageYOffset + ( window.innerHeight + 200 ) ) > ( productList.offsetTop + productList.offsetHeight ) && loading === false && nextPageUrl !== null ) {
				// Define loading, to prevent double load
				loading = true;
				// Add loading spinner info thingy
				productList.appendChild( loadingHtml );

				// Fetch next page products
				jQuery.get( nextPageUrl, ( response ) => {
					// Create new hidden DOM
					const htmlObject = document.createElement( 'html' );
					htmlObject.innerHTML = response;

					// Fetch new data from the hidden DOM
					const newProducts = Array.from( htmlObject.querySelectorAll( newItemsSelector ) );
					const loadingSpinner = document.getElementById( 'maksimer-loading' );
					nextPage = htmlObject.querySelector( nextPageSelector );

					// Add the new products to the existing list
					newProducts.forEach( ( element ) => {
						productList.appendChild( element );
					} );

					// Define the next page url
					if ( nextPage ) {
						nextPageUrl = nextPage.getAttribute( 'href' );
					} else {
						nextPageUrl = null;
					}

					// Remove loading info
					if ( loadingSpinner ) {
						loader.classList.add( 'invisible' );
						loadingSpinner.parentNode.removeChild( loadingSpinner );
					}

					// Deactivate loading; get ready for round two. - FIGHT!
					loading = false;
				} );
			}
		} );
	}
}

export function maksimerBrowserDetection() {
	const isChrome = /Chrome/.test( navigator.userAgent ) && /Google Inc/.test( navigator.vendor );
	const isSafari = /Safari/.test( navigator.userAgent ) && /Apple Computer/.test( navigator.vendor );
	const isFirefox = navigator.userAgent.toLowerCase().indexOf( 'firefox' ) > -1;
	const isIE = window.navigator.userAgent.indexOf( 'MSIE ' );
	const body = $( 'body' );
	if ( isChrome ) {
		body.addClass( 'mks-chrome' );
	}
	if ( isSafari ) {
		body.addClass( 'mks-safari' );
	}
	if ( isFirefox ) {
		body.addClass( 'mks-firefox' );
	}
	if ( isIE > 0 || !! navigator.userAgent.match( /Trident.*rv:11\./ ) ) {
		body.addClass( 'mks-ms-explorer' );
	}
	if ( /Edge\/\d./i.test( navigator.userAgent ) ) {
		body.addClass( 'mks-edge' );
	}
}
